<template>
    <div class="rets">
        <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slideshow="ratio: 7:3; animation: push">

            <ul class="uk-slideshow-items">
                <li>
                    <img src="../../../assets/FINCOR-.jpg" alt="" uk-cover>
                </li>


            </ul>

            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>

        </div>
    </div>
</template>

<script>
    export default {
        name: "carousel"
    }
</script>

<style scoped>
    /* Custom, iPhone Retina */
    @media only screen and (min-width : 320px) {
        .rets{
            margin-top: -20px;
        }
    }

    /* Extra Small Devices, Phones */
    @media only screen and (min-width : 480px) {

    }

    /* Small Devices, Tablets */
    @media only screen and (min-width : 768px) {

    }

    /* Medium Devices, Desktops */
    @media only screen and (min-width : 992px) {

    }

    /* Large Devices, Wide Screens */
    @media only screen and (min-width : 1200px) {
        .rets{
            margin-top: auto;
        }
    }
</style>